import React, { useEffect, useState } from "react";
import { AppAlert } from "../../utils";
import { Table, Modal, ModalBody, Label } from "reactstrap";
import {
  getFoodPlans,
  joinToProgram,
  removeFromPlan,
  getFoodList,
  addNewPlan,
  removePlan,
  usersOnPlan,
} from "./_food_srv";
import momentK from "jalali-moment";
import DatePicker from "react-modern-calendar-datepicker";
import Select from "react-select";
import Btn from "../../components/Btn/Btn";
import { RemoveBtn } from "../../components/Btn/extra";
import { CanView, GetUserRole } from "../../utils/checkRoles";
import "./food.css";

function renderImIn(status) {
  if (status === 1) {
    return <span style={{ color: "green" }}>هستم</span>;
  } else {
    return <span style={{ color: "red" }}>نیستم</span>;
  }
}

function WeeklyProgram(props) {
  const [foodList, setFoodList] = useState([]);
  const [plans, setPlans] = useState([]);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [selectedDay, setSelectedDay] = useState(null);
  const [selectedFood, setSelectedFood] = useState(null);
  const [usersOnPlanList, setUsersOnPlanList] = useState([]);
  const [usersOnPlanModal, setUsersOnPlanModal] = useState(false);

  function fetchPlans() {
    getFoodPlans()
      .then((res) => {
        if (res.status === 200) {
          setPlans(res.data);
        }
      })
      .catch((err) => {
        if (err.response) AppAlert(err.response.status, err.response.data);
      });
  }

  function fetchUsersOnPlan(planId) {
    usersOnPlan(planId)
      .then((res) => {
        if (res.status === 200) {
          setUsersOnPlanList(res.data);
          setUsersOnPlanModal(true);
        }
      })
      .catch((err) => {
        if (err.response) AppAlert(err.response.status, err.response.data);
      });
  }

  function fetchFoodList() {
    getFoodList()
      .then((res) => {
        if (res.status === 200) {
          var options = [];
          for (var i in res.data) {
            options.push({ value: res.data[i].Id, label: res.data[i].Title });
          }
          setFoodList(options);
        }
      })
      .catch((err) => {
        if (err.response) AppAlert(err.response.status, err.response.data);
      });
  }

  function deletePlan(planId) {
    removePlan(planId)
      .then((res) => {
        if (res.status === 200) {
          AppAlert(200, res.data);
          fetchPlans();
        }
      })
      .catch((err) => {
        if (err.response) AppAlert(err.response.status, err.response.data);
      });
  }
  useEffect(() => {
    fetchPlans();
    fetchFoodList();
  }, []);

  const commandInOut = (userCurrentStatus, ProgramId) => {
    if (userCurrentStatus === 1) {
      removeFromPlan(ProgramId)
        .then((res) => {
          if (res.status === 200) {
            fetchPlans();
            AppAlert(200, res.data);
          }
        })
        .catch((err) => {
          if (err.response) AppAlert(err.response.status, err.response.data);
        });
    } else {
      joinToProgram(ProgramId)
        .then((res) => {
          if (res.status === 200) {
            fetchPlans();
            AppAlert(200, res.data);
          }
        })
        .catch((err) => {
          if (err.response) AppAlert(err.response.status, err.response.data);
        });
    }
  };
  const ImInOut = (e) => {
    return (
      <Btn
        onClick={() => {
          commandInOut(e.status, e.program);
        }}
        style={{ backgroundColor: e.status === 1 ? "red" : "green" }}
        children={e.status === 1 ? "لغو حضور" : "حضور در برنامه"}
      />
    );
  };

  function renderTableRow(e, index) {
    return (
      <tr key={index}>
        {/* <th scope="row">{e.Id}</th> */}
        <th scope="row">
          {momentK(e.Date).locale("fa").format("dddd") +
            " " +
            momentK(e.Date).format("jYYYY/jMM/jDD")}
        </th>
        <td>{e.FoodTitle}</td>
        <td>
          <span
            onClick={() =>
              GetUserRole() === 2 ? fetchUsersOnPlan(e.Id) : null
            }
            style={{ cursor: "pointer" }}
          >
            {e.PlanMembers}
          </span>
        </td>
        <td>{renderImIn(e.AreYouIn)}</td>
        <td>
          <div>
            <ImInOut status={e.AreYouIn} program={e.Id} />
            <CanView role={2}>
              <RemoveBtn
                onClick={() => {
                  deletePlan(e.Id);
                }}
              />
            </CanView>
          </div>
        </td>
      </tr>
    );
  }

  function renderAccRow(e, index) {
    return (
      <div key={index} className="planAcc">
          <div className="planAccHeader">
            <div>
            {momentK(e.Date).locale("fa").format("dddd") +
            " " +
            momentK(e.Date).format("jYYYY/jMM/jDD")}
            </div>
            <div>
            {renderImIn(e.AreYouIn)}
            </div>
          </div>
        {/* <th scope="row">{e.Id}</th> */}
        <div className="planAccBody">
            <div>
            {e.FoodTitle}
            </div>
            <div onClick={() =>
              GetUserRole() === 2 ? fetchUsersOnPlan(e.Id) : null
            }
            style={{ cursor: "pointer" }}>
                {e.PlanMembers} نفر
            </div>
            <div>
                <ImInOut status={e.AreYouIn} program={e.Id} />
                <CanView role={2}>
                <RemoveBtn
                    onClick={() => {
                    deletePlan(e.Id);
                    }}
                />
                </CanView>
          </div>
        </div>
      </div>
    );
  }

  function submitNewPlan() {
    if ((selectedFood !== null) & (selectedDay !== null)) {
      var dd = momentK(
        `${selectedDay.year}/${selectedDay.month}/${selectedDay.day}`,
        "jYYYY/jMM/jDD"
      ).format("YYYY-MM-DD HH:MM:SS");
      addNewPlan(selectedFood.value, dd)
        .then((res) => {
          if (res.status === 200) {
            setOpenAddModal(false);
            AppAlert(200, "برنامه غذایی جدید با موفقیت اضافه شد.");
            fetchPlans();
            console.log(res);
          }
        })
        .catch((err) => {
          if (err.response) AppAlert(err.response.status, err.response.data);
        });
    } else {
      AppAlert(400, "لطفا تاریخ برنامه و نوع غذایی آن را تعیین کنید");
    }
  }

  return (
    <div>
      <CanView role={2}>
        <Btn
          style={{ backgroundColor: "var(--main)", marginTop: 10 }}
          onClick={() => {
            setOpenAddModal(true);
          }}
          children={"افزودن برنامه"}
        />
      </CanView>
      <Modal
        isOpen={openAddModal}
        centered
        toggle={() => setOpenAddModal(!openAddModal)}
      >
        <ModalBody>
          <h5>افزودن برنامه غذایی</h5>
          <Label>انتخاب روز غذایی</Label>
          <DatePicker
            value={selectedDay}
            onChange={setSelectedDay}
            inputPlaceholder="نمایش تقویم"
            shouldHighlightWeekends
            locale="fa"
          />
          <Label>انتخاب غذای روز</Label>
          <Select
            options={foodList}
            placeholder="انتخاب غذا"
            onChange={(e) => setSelectedFood(e)}
          />
          <Btn
            onClick={() => {
              submitNewPlan();
            }}
            style={{ backgroundColor: "green", marginTop: 10 }}
            children={"ثبت برنامه غذایی"}
          />
        </ModalBody>
      </Modal>
      <Modal
        isOpen={usersOnPlanModal}
        centered
        toggle={() => {
          setUsersOnPlanModal(!usersOnPlanModal);
          setUsersOnPlanList([]);
        }}
      >
        <ModalBody>
          <h5>افراد حاضر در این برنامه غذایی</h5>
          <hr />
          {usersOnPlanList.length > 0
            ? usersOnPlanList.map((item, index) => {
                return (
                  <div key={index} style={{ marginBottom: 5 }}>
                    {item.FirstName} {item.Lastname}
                  </div>
                );
              })
            : null}
        </ModalBody>
      </Modal>
      <Table className="whiteBox ScollingTable foodTbl">
        <thead>
          <tr>
            <th>تاریخ</th>
            <th>نام غذا</th>
            <th>تعداد حاضرین</th>
            <th>وضعیت حضور شما</th>
            <th>عملیات</th>
          </tr>
        </thead>
        <tbody>
          {plans.length > 0
            ? plans.map((item, index) => {
                return renderTableRow(item, index);
              })
            : null}
        </tbody>
      </Table>
      <div className="foodAcc">
        {plans.length > 0
          ? plans.map((item, index) => {
              return renderAccRow(item, index);
            })
          : null}
      </div>
    </div>
  );
}

export default WeeklyProgram;
